import type {
	PictureConfiguration,
	Palette,
} from "@brickme/project-core/src/model/picture.ts";
import {
	originPosition,
	multiplySize,
} from "@brickme/project-core/src/model/geom.ts";
import { pixAPicKit } from "@brickme/project-core/src/pix-a-pic.ts";
import { availableDetailValues } from "@brickme/project-core/src/model/detail-filter.ts";
import { getDefaultLayout } from "./layout-permutations.ts";

const defaultContrast = 0.15;
const defaultSaturation = 0;
const defaultBrightness = 0;

type Options = {
	readonly numberOfKits: number;
	readonly kitsPalette: Palette;
};

function createDefaultPaletteMode({
	kitsPalette,
}: Pick<Options, "kitsPalette">): PictureConfiguration["paletteMode"] {
	return {
		type: "hybrid",
		palette: kitsPalette.map((p) => p.brick),
		numberOfExtraColours: 0,
	};
}

function createDefaultPictureConfiguration({
	numberOfKits,
	kitsPalette,
}: Options): PictureConfiguration {
	const numberOfBasePlates = getDefaultLayout(numberOfKits);
	const basePlateSize = pixAPicKit.basePlateSize;
	const defaultDetailFilter =
		availableDetailValues[Math.floor((availableDetailValues.length - 1) / 2)];
	return {
		imageZoom: 1,
		imageZoomOffset: originPosition,
		basePlateSize,
		numberOfBasePlates,
		numberOfBricks: multiplySize(numberOfBasePlates, basePlateSize),
		paletteMode: createDefaultPaletteMode({ kitsPalette }),
		removeBackground: undefined,
		enhanceFaces: false,
		fixFaceColours: false,
		detailFilter: defaultDetailFilter,
		brightness: defaultBrightness,
		contrast: defaultContrast,
		saturation: defaultSaturation,
		pen: [],
		updatedAt: Date.now(),
	};
}

export { createDefaultPaletteMode };
export default createDefaultPictureConfiguration;
